/**
 * RefreshIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const RefreshIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.75 13.009a1 1 0 0 0-1 .77 7 7 0 0 1-11.69 3.23 7.036 7.036 0 0 1 9.95-9.95l-2.1 2.1a.5.5 0 0 0 .36.85h5.24a.5.5 0 0 0 .5-.5v-5.29a.5.5 0 0 0-.5-.5.47.47 0 0 0-.35.14l-1.79 1.79a9 9 0 0 0-8.21-2.46 8.6 8.6 0 0 0-3 1.23 9 9 0 0 0-3.95 9.52 8.7 8.7 0 0 0 1.21 2.93 9 9 0 0 0 9.5 3.94 8.3 8.3 0 0 0 3-1.24 9 9 0 0 0 3.81-5.31 1 1 0 0 0-1-1.25z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const RefreshIcon = makeIcon('RefreshIcon', RefreshIconSvg)
